/**
 * @generated SignedSource<<42b58b01a1994dfcf0a3ac5a5b822aa3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionDetailIssueList_FiltersAsync$data = {
  readonly " $fragmentSpreads": FragmentRefs<"filters_softwareReleasesVersionDetailIssueList">;
  readonly " $fragmentType": "async_softwareReleasesVersionDetailIssueList_FiltersAsync";
};
export type async_softwareReleasesVersionDetailIssueList_FiltersAsync$key = {
  readonly " $data"?: async_softwareReleasesVersionDetailIssueList_FiltersAsync$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetailIssueList_FiltersAsync">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "filters_softwareReleasesVersionDetailIssueList"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "80684c6429225cfc5da72844f8d61f76";

export default node;
